import { useEffect, useState } from 'react';
import DirectInput from '../../../components/directInput/DirectInput';
import ReactLoading from 'react-loading';
import { useLocation, useNavigate } from 'react-router-dom';
import BackIcon from '../../../assets/icons/trvto_ArrowBack.svg';
import Textarea from '../../../components/textarea/Textarea';
import { addFaqSubmit } from '../supFaqFunction/addFaq';
import { editFaqSubmit } from '../supFaqFunction/editFaq';

const AddFaq = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [faqData, setfaqData] = useState({
        id: '',
        question: '',
        answer: ''
    });

    useEffect(() => {
        if (!location.state.faqdata) return;
        const data = location.state.faqdata;
        setfaqData({
            id: data._id,
            question: data.question,
            answer: data.answer
        });
    }, [location.state.faqData]);

    const handleSubmit = async () => {
        if (faqData.id) {
            const res = await editFaqSubmit(faqData.id, faqData, setLoading);
            if (res === 200) {
                navigate(-1);
            }
        } else {
            const { id, ...rest } = faqData;
            const res = await addFaqSubmit({ ...rest, type: location.state.selectedType }, setLoading);
            if (res === 200) {
                navigate(-1);
            }
        }
    };

    return (
        <div>
            {loading && (
                <div className='loadingBackground'>
                    <ReactLoading type='spin' color='#006aff' className='loadingSpin' />
                </div>
            )}
            <button className='backBtn' onClick={() => navigate(-1)}>
                <img src={BackIcon} alt='back' />
                Back to FAQ
            </button>
            <h1 className='orgPackUpH1'>Create New FAQ</h1>
            <div className='orgPackUpSecDiv'>
                <DirectInput
                    label='Question'
                    name='question'
                    value={faqData?.question}
                    type='text'
                    placeholder='Question'
                    setFormData={setfaqData}
                />
                <Textarea
                    label='Answer'
                    name='answer'
                    value={faqData.answer}
                    setFormData={setfaqData}
                    min={50}
                    limit={1000}
                />
                <button type='button' className='orgPackUpSubmitBtn blueBtn' onClick={() => handleSubmit()}>
                    Submit
                </button>
            </div>
        </div>
    );
};

export default AddFaq;
